var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ri:file-excel-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 2.22266L21 7.22266V21.2307C20.9997 21.4938 20.895 21.7462 20.7088 21.9322C20.5226 22.1182 20.2702 22.2227 20.007 22.2227H3.993C3.73038 22.2208 3.47902 22.1158 3.29322 21.9301C3.10742 21.7445 3.00209 21.4933 3 21.2307V3.21466C3 2.66666 3.445 2.22266 3.993 2.22266H16ZM13.2 12.2227L16 8.22266H13.6L12 10.5087L10.4 8.22266H8L10.8 12.2227L8 16.2227H10.4L12 13.9367L13.6 16.2227H16L13.2 12.2227Z",
    fill: "#0FA958"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExl);
export default __webpack_public_path__ + "static/media/exl.a2ca86130ed8ec2ef0664689cb47fc61.svg";
export { ForwardRef as ReactComponent };